<div class="filter-container grid mb-2" style="align-items: center;">
  <div class="col-fixed" style="display: flex; gap: 1rem; align-items: center;">
    <p-multiSelect
      (onChange)="loadChartData()"
      [(ngModel)]="selectedCategories"
      [options]="categories"
      placeholder="Categories"
    >
      <ng-template let-option pTemplate="item">
        <div class="inline-block align-middle">
          <span class="ml-1 mt-1">{{ option }}</span>
        </div>
      </ng-template>
    </p-multiSelect>
    <button
      pButton
      type="button"
      class="p-button-outlined p-button-rounded p-button-sm options-btn"
      (click)="decreaseLabelSize()"
      [disabled]="labelSize <= 10"
    >−
    </button>
    <button
      pButton
      type="button"
      class="p-button-outlined p-button-rounded p-button-sm options-btn"
      (click)="increaseLabelSize()"
      [disabled]="labelSize >= 20"
    >+
    </button>
  </div>
</div>


<div class="grid" style="height: 100vh;">
  <div [ngClass]="{ 'col-8': showPanel }" class="col" id="chart">
    @if (chartOptions.chart) {
      <apx-chart [annotations]="chartOptions.annotations"
                 [chart]="chartOptions.chart"
                 [dataLabels]="chartOptions.dataLabels"
                 [series]="chartOptions.series"
                 [tooltip]="chartOptions.tooltip"
                 [xaxis]="chartOptions.xaxis"
                 [yaxis]="chartOptions.yaxis"
                 style="height: 100%; display: block"
      ></apx-chart>
    } @else {
      <p-progress-spinner ariaLabel="loading" class="spinner" />
    }
  </div>
  @if (showPanel) {
    <div class="col-4">
      <app-skillmap-panel
        [selectedDataLabel]="selectedDataLabel"
        [teamSkillData]="teamSkillEntry"
        [data]="userKnowledgeData"
        (closePanel)="showPanelIsFalse()"
      ></app-skillmap-panel>
    </div>
  }

</div>
